document.addEventListener("DOMContentLoaded", () => {
  const data = {
    useLocation: null,
    homeUse: [],
    roadUse: null,
    firstName: null,
    lastName: null,
    address: null,
    email: null,
    phoneNumber: null,
    discounted: false,
  };

  window.quizData = data;

  const quiz = document.getElementById('quiz');
  const quizCloseButton = document.getElementById('quiz-close-button');
  const quizTriggers = document.querySelectorAll('.quiz-trigger');

  if (quizCloseButton) quizCloseButton.addEventListener('click', () => closeQuiz(data))
  quiz.addEventListener('click', (e) => e.stopPropagation());

  quizTriggers.forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      showquizPopup(data);
      showQuizStep1(data);
    });
  });

  const quizPopup = document.getElementById('quiz-popup');

  if (quizPopup) quizPopup.addEventListener('click', () => closeQuiz(data));

  initializeChargebeeProductTracking('cb-residential-standard-cc', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'QUIZCHECKOUT')
  initializeChargebeeProductTracking('cb-residential-advanced-cc', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'QUIZCHECKOUT')
  initializeChargebeeProductTracking('cb-travel-standard-cc', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'QUIZCHECKOUT')
  initializeChargebeeProductTracking('cb-travel-advanced-cc', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'QUIZCHECKOUT')
  initializeChargebeeProductTracking('cb-residential-standard-with-coupon', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-residential-advanced-with-coupon', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-travel-standard-with-coupon', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-travel-advanced-with-coupon', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'Oklahoma')
  initializeChargebeeProductTracking('cb-residential-standard-with-coupon-15', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-residential-advanced-with-coupon-15', 'UNLIMITED-RESIDENTIAL-PLAN', ['UNLIMITED-RESIDENTIAL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-travel-standard-with-coupon-15', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Standard-Protection-USD'], 'CONNECT15')
  initializeChargebeeProductTracking('cb-travel-advanced-with-coupon-15', 'UNLIMITED-TRAVEL-PLAN', ['UNLIMITED-TRAVEL-PLAN-USD-Monthly', 'Sim-Card-Activation-Kit-USD', 'Advanced-Protection-USD'], 'CONNECT15')
});

const openQuiz = () => {
  const quiz = document.getElementById('quiz');
  const quizError = document.getElementById('quiz-error');
  const quizErrorMessage = document.getElementById('quiz-error-message');

  quizError.style.display = 'none';
  quizErrorMessage.innerText = 'An error occurred';
  quiz.style.display = 'flex';
}

const closeQuiz = (data) => {
  const quiz = document.getElementById('quiz');
  quiz.style.display = 'none';

  window.quizData.type = window.quizData.previousType;
  hideQuizPopup(data);
}

const showQuizStep1 = (data) => {
  const quizStep1 = document.getElementById('quiz-step-1');
  const quizStep2Road = document.getElementById('quiz-step-2-road');
  const quizStep2Home = document.getElementById('quiz-step-2-home');
  const quizStep3 = document.getElementById('quiz-step-3');
  const quizStep4 = document.getElementById('quiz-step-4');
  const quizStep5 = document.getElementById('quiz-step-5');

  quizStep5.style.display = 'none';
  quizStep4.style.display = 'none';
  quizStep3.style.display = 'none';
  quizStep2Road.style.display = 'none';
  quizStep2Home.style.display = 'none';
  quizStep1.style.display = 'flex';

  if (data.type == 'section' && data.currentStep == 2) {
    data.sectionElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  data.currentStep = 1;

  const quizPopupBackButton = document.getElementById('quiz-back-button');
  quizPopupBackButton.style.display = 'none';

  const quizProgressBarStep1 = document.getElementById('quiz-progress-bar-fill-1');
  const quizProgressBarStep2 = document.getElementById('quiz-progress-bar-fill-2');
  const quizProgressBarStep3 = document.getElementById('quiz-progress-bar-fill-3');
  const quizProgressBarStep4 = document.getElementById('quiz-progress-bar-fill-4');

  quizProgressBarStep1.style.width = '0%';
  quizProgressBarStep2.style.width = '0%';
  quizProgressBarStep3.style.width = '0%';
  quizProgressBarStep4.style.width = '0%';

  const quizProgressText = document.getElementById('quiz-progress-text');
  quizProgressText.innerText = 'Step 1 of 4';
  quizProgressText.style.display = 'block';

  const quizProgress = document.getElementById('quiz-progress');
  quizProgress.style.display = 'flex';

  const quizMainHeading1 = document.getElementById('quiz-heading-1');
  const quizMainHeading2 = document.getElementById('quiz-heading-2');
  const quizMainheading3 = document.getElementById('quiz-heading-3');
  const quizMainheading4 = document.getElementById('quiz-heading-4');
  const quizMainheading5 = document.getElementById('quiz-heading-5');
  const quizMainheading6 = document.getElementById('quiz-heading-6');

  quizMainHeading1.style.display = 'flex';
  quizMainHeading2.style.display = 'none';
  quizMainheading3.style.display = 'none';
  quizMainheading4.style.display = 'none';
  quizMainheading5.style.display = 'none';
  quizMainheading6.style.display = 'none';

  const quizStep1FormOptions = document.getElementById('quiz-step-1-form-content-options');
  const quizStep1Buttons = quizStep1FormOptions.querySelectorAll('button');
  const quizStep1Submit = document.getElementById('quiz-step-1-submit');

  const quizStep1ButtonEventHandler = (e) => {
    if (data.useLocation == e.currentTarget.dataset.useLocation) {
    } else {
      data.useLocation = e.currentTarget.dataset.useLocation;

      quizStep1Buttons.forEach((button) => {
        button.classList.remove('quiz-form-content-button-selected');
      })

      e.currentTarget.classList.add('quiz-form-content-button-selected');
      quizStep1Submit.disabled = false;
    }

    if (data.type == 'popup') {
      quizStep1Submit.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  }

  const quizStep1SubmitEventHandler = (e) => {
    e.preventDefault();

    quizStep1Buttons.forEach((button, i) => {
      button.removeEventListener('click', quizStep1ButtonEventHandler, true);
    });
    quizStep1Submit.removeEventListener('click', quizStep1SubmitEventHandler, true);

    if (data.useLocation == 'home') {
      showQuizStep2Home(data);
    } else {
      showQuizStep2Road(data);
    }
  }

  quizStep1Buttons.forEach((button) => {
    button.addEventListener('click', quizStep1ButtonEventHandler, true);
  });

  quizStep1.addEventListener('submit', quizStep1SubmitEventHandler, true);

  if (data.useLocation != null) {
    quizStep1Buttons.forEach((button) => {
      if (data.useLocation == button.dataset.useLocation) {
        button.classList.add('quiz-form-content-button-selected');
        quizStep1Submit.disabled = false;
      }
    });
  }
}

const showQuizStep2Road = (data) => {
  const quizStep1 = document.getElementById('quiz-step-1');
  const quizStep2Road = document.getElementById('quiz-step-2-road');
  const quizStep3 = document.getElementById('quiz-step-3');
  const quizStep4 = document.getElementById('quiz-step-4');
  const quizStep5 = document.getElementById('quiz-step-5');

  quizStep5.style.display = 'none';
  quizStep1.style.display = 'none';
  quizStep3.style.display = 'none';
  quizStep4.style.display = 'none';
  quizStep2Road.style.display = 'flex';

  if (data.type == 'section') {
    data.sectionElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  data.currentStep = 2;

  const quizPopupBackButton = document.getElementById('quiz-back-button');
  quizPopupBackButton.style.display = 'flex';

  quizPopupBackButton.onclick = () => {
    showQuizStep1(data);
  }

  const quizProgressBarStep1 = document.getElementById('quiz-progress-bar-fill-1');
  const quizProgressBarStep2 = document.getElementById('quiz-progress-bar-fill-2');
  const quizProgressBarStep3 = document.getElementById('quiz-progress-bar-fill-3');
  const quizProgressBarStep4 = document.getElementById('quiz-progress-bar-fill-4');

  quizProgressBarStep1.style.width = '100%';
  quizProgressBarStep2.style.width = '0%';
  quizProgressBarStep3.style.width = '0%';
  quizProgressBarStep4.style.width = '0%';

  const quizProgressText = document.getElementById('quiz-progress-text');
  quizProgressText.innerText = 'Step 2 of 4';
  quizProgressText.style.display = 'block';

  const quizProgress = document.getElementById('quiz-progress');
  quizProgress.style.display = 'flex';

  const quizMainHeading1 = document.getElementById('quiz-heading-1');
  const quizMainHeading2 = document.getElementById('quiz-heading-2');
  const quizMainheading3 = document.getElementById('quiz-heading-3');
  const quizMainheading4 = document.getElementById('quiz-heading-4');
  const quizMainheading5 = document.getElementById('quiz-heading-5');
  const quizMainheading6 = document.getElementById('quiz-heading-6');

  quizMainHeading1.style.display = 'none';
  quizMainHeading2.style.display = 'flex';
  quizMainheading3.style.display = 'none';
  quizMainheading4.style.display = 'none';
  quizMainheading5.style.display = 'none';
  quizMainheading6.style.display = 'none';

  const quizPopup2Main = document.getElementById('quiz');
  quizPopup2Main.scrollTo(0, 0);

  const quizStep2RoadFormContent = document.getElementById('quiz-step-2-road-form-content');
  const quizStep2RoadButtons = quizStep2RoadFormContent.querySelectorAll('ul button');
  const quizStep2RoadSubmit = document.getElementById('quiz-step-2-road-submit');

  const quizStep2RoadSubmitEventHandler = (e) => {
    e.preventDefault();

    quizStep2RoadButtons.forEach((button) => {
      button.removeEventListener('click', quizStep2RoadButtonEventHandler, true);
    });
    quizStep2RoadSubmit.removeEventListener('click', quizStep2RoadSubmitEventHandler, true);

    showQuizStep3(data);
  }

  const quizStep2RoadButtonEventHandler = (e) => {
    e.preventDefault();

    if (data.roadUse == e.currentTarget.dataset.roadUse) {
    } else {
      data.roadUse = e.currentTarget.dataset.roadUse;

      quizStep2RoadButtons.forEach((button) => {
        button.classList.remove('quiz-form-content-button-selected');
      })

      e.currentTarget.classList.add('quiz-form-content-button-selected');
      quizStep2RoadSubmit.disabled = false;
    }

    if (data.type == 'popup') {
      quizStep2RoadSubmit.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  }

  quizStep2RoadButtons.forEach((button) => {
    button.addEventListener('click', quizStep2RoadButtonEventHandler, true);
  });
  quizStep2RoadSubmit.addEventListener('click', quizStep2RoadSubmitEventHandler, true);

  if (data.roadUse != null) {
    quizStep2RoadButtons.forEach((button) => {
      if (data.roadUse == button.dataset.roadUse) {
        button.classList.add('quiz-form-content-button-selected');
        quizStep2RoadSubmit.disabled = false;
      }
    });
  }
}

const showQuizStep2Home = (data) => {
  const quizStep1 = document.getElementById('quiz-step-1');
  const quizStep2Home = document.getElementById('quiz-step-2-home');
  const quizStep3 = document.getElementById('quiz-step-3');
  const quizStep4 = document.getElementById('quiz-step-4');
  const quizStep5 = document.getElementById('quiz-step-5');

  quizStep5.style.display = 'none';
  quizStep1.style.display = 'none';
  quizStep3.style.display = 'none';
  quizStep4.style.display = 'none';
  quizStep2Home.style.display = 'flex';


  if (data.type == 'section') {
    data.sectionElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  data.currentStep = 2;

  const quizPopupBackButton = document.getElementById('quiz-back-button');
  quizPopupBackButton.style.display = 'flex';

  quizPopupBackButton.onclick = () => {
    showQuizStep1(data);
  }

  const quizProgressBarStep1 = document.getElementById('quiz-progress-bar-fill-1');
  const quizProgressBarStep2 = document.getElementById('quiz-progress-bar-fill-2');
  const quizProgressBarStep3 = document.getElementById('quiz-progress-bar-fill-3');
  const quizProgressBarStep4 = document.getElementById('quiz-progress-bar-fill-4');

  quizProgressBarStep1.style.width = '100%';
  quizProgressBarStep2.style.width = '0%';
  quizProgressBarStep3.style.width = '0%';
  quizProgressBarStep4.style.width = '0%';

  const quizProgressText = document.getElementById('quiz-progress-text');
  quizProgressText.innerText = 'Step 2 of 4';
  quizProgressText.style.display = 'block';

  const quizProgress = document.getElementById('quiz-progress');
  quizProgress.style.display = 'flex';

  const quizMainHeading1 = document.getElementById('quiz-heading-1');
  const quizMainHeading2 = document.getElementById('quiz-heading-2');
  const quizMainheading3 = document.getElementById('quiz-heading-3');
  const quizMainheading4 = document.getElementById('quiz-heading-4');
  const quizMainheading5 = document.getElementById('quiz-heading-5');
  const quizMainheading6 = document.getElementById('quiz-heading-6');

  quizMainHeading1.style.display = 'none';
  quizMainHeading2.style.display = 'none';
  quizMainheading3.style.display = 'flex';
  quizMainheading4.style.display = 'none';
  quizMainheading5.style.display = 'none';
  quizMainheading6.style.display = 'none';

  const quizPopup2Main = document.getElementById('quiz');
  quizPopup2Main.scrollTo(0, 0);

  const quizStep2HomeFormContent = document.getElementById('quiz-step-2-home-form-content');
  let quizStep2HomeButtons = quizStep2HomeFormContent.querySelectorAll('ul button');
  const quizStep2HomeSelectAll = document.getElementById('quiz-form-select-all');
  const quizStep2HomeSubmit = document.getElementById('quiz-step-2-home-submit');

  const quizStep2HomeSubmitEventHandler = (e) => {
    e.preventDefault();

    quizStep2HomeButtons.forEach((button) => {
      button.removeEventListener('click', quizStep2HomeButtonEventHandler, true);
    });
    quizStep2HomeSubmit.removeEventListener('click', quizStep2HomeSubmitEventHandler, true);

    showQuizStep3(data);
  }

  const quizStep2HomeButtonEventHandler = (e) => {
    e.preventDefault();

    if (data.homeUse.indexOf(e.currentTarget.dataset.homeUse) > -1) {
      data.homeUse = data.homeUse.filter(d => d !== e.currentTarget.dataset.homeUse);
      e.currentTarget.classList.remove('quiz-form-content-button-selected');
    } else {
      data.homeUse = [...data.homeUse, e.currentTarget.dataset.homeUse];
      e.currentTarget.classList.add('quiz-form-content-button-selected');
    }

    if (data.homeUse.length > 0) {
      quizStep2HomeSubmit.disabled = false;
    } else {
      quizStep2HomeSubmit.disabled = true;
    }

    if (data.type == 'popup') {
      quizStep2HomeSubmit.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  }

  quizStep2HomeButtons.forEach((button) => {
    const clone = button.cloneNode(true);
    const parentElement = button.parentElement
    parentElement.innerHTML = '';
    parentElement.appendChild(clone)
    clone.addEventListener('click', quizStep2HomeButtonEventHandler, true);
  });

  quizStep2HomeButtons = quizStep2HomeFormContent.querySelectorAll('ul button');

  const clone = quizStep2HomeSelectAll.cloneNode(true);
  const parentElement = quizStep2HomeSelectAll.parentElement
  parentElement.innerHTML = '';
  parentElement.appendChild(clone)

  clone.addEventListener('click', (e) => {
    e.preventDefault();
    data.homeUse = ['work-from-hone', 'streaming-entertainment', 'gaming-performance', 'everyday-home-use']

    quizStep2HomeButtons.forEach((button) => {
      button.classList.add('quiz-form-content-button-selected');
    })

    quizStep2HomeSubmit.disabled = false;

    if (data.type == 'popup') {
      quizStep2HomeSubmit.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  });

  quizStep2HomeSubmit.addEventListener('click', quizStep2HomeSubmitEventHandler, true);

  if (data.homeUse.length) {
    quizStep2HomeButtons.forEach((button) => {
      if (data.homeUse.indexOf(button.dataset.homeUse) > -1) {
        button.classList.add('quiz-form-content-button-selected');
        quizStep2HomeSubmit.disabled = false;
      }
    });
  }
}

const showQuizStep3 = (data) => {
  const quizStep1 = document.getElementById('quiz-step-1');
  const quizStep2Road = document.getElementById('quiz-step-2-road');
  const quizStep2Home = document.getElementById('quiz-step-2-home');
  const quizStep3 = document.getElementById('quiz-step-3');
  const quizStep4 = document.getElementById('quiz-step-4');
  const quizStep5 = document.getElementById('quiz-step-5');

  quizStep5.style.display = 'none';
  quizStep4.style.display = 'none';
  quizStep3.style.display = 'flex';
  quizStep2Road.style.display = 'none';
  quizStep2Home.style.display = 'none';
  quizStep1.style.display = 'none';

  if (data.type == 'section') {
    data.sectionElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  data.currentStep = 3;

  const quizPopupBackButton = document.getElementById('quiz-back-button');
  quizPopupBackButton.style.display = 'flex';

  quizPopupBackButton.onclick = () => {
    if (data.useLocation == 'home') {
      showQuizStep2Home(data);
    } else {
      showQuizStep2Road(data);
    }
  }

  const quizProgressBarStep1 = document.getElementById('quiz-progress-bar-fill-1');
  const quizProgressBarStep2 = document.getElementById('quiz-progress-bar-fill-2');
  const quizProgressBarStep3 = document.getElementById('quiz-progress-bar-fill-3');
  const quizProgressBarStep4 = document.getElementById('quiz-progress-bar-fill-4');

  quizProgressBarStep1.style.width = '100%';
  quizProgressBarStep2.style.width = '100%';
  quizProgressBarStep3.style.width = '0%';
  quizProgressBarStep4.style.width = '0%';

  const quizProgressText = document.getElementById('quiz-progress-text');
  quizProgressText.innerText = 'Step 3 of 4';
  quizProgressText.style.display = 'block';

  const quizProgress = document.getElementById('quiz-progress');
  quizProgress.style.display = 'flex';

  const quizMainHeading1 = document.getElementById('quiz-heading-1');
  const quizMainHeading2 = document.getElementById('quiz-heading-2');
  const quizMainheading3 = document.getElementById('quiz-heading-3');
  const quizMainheading4 = document.getElementById('quiz-heading-4');
  const quizMainheading5 = document.getElementById('quiz-heading-5');
  const quizMainheading6 = document.getElementById('quiz-heading-6');

  quizMainHeading1.style.display = 'none';
  quizMainHeading2.style.display = 'none';
  quizMainheading3.style.display = 'none';
  quizMainheading4.style.display = 'flex';
  quizMainheading5.style.display = 'none';
  quizMainheading6.style.display = 'none';

  const quizPopup2Main = document.getElementById('quiz');
  quizPopup2Main.scrollTo(0, 0);

  const quizStep3Submit = document.getElementById('quiz-step-3-submit');
  const quizStep3NoDiscount = document.getElementById('quiz-step-3-continue');

  const residentialPlanCard = document.getElementById('quiz-step-3-plan-card-residential');
  const travelPlanCard = document.getElementById('quiz-step-3-plan-card-travel');

  if (data.useLocation == 'home') {
    residentialPlanCard.style.display = 'flex';
    travelPlanCard.style.display = 'none';
  } else {
    residentialPlanCard.style.display = 'none';
    travelPlanCard.style.display = 'flex';
  }

  const quizStep3SubmitEventHandler = (e) => {
    e.preventDefault();

    data.discounted = true;

    showQuizStep4(data);
  }

  const quizStep3NoDiscountEventHandler = (e) => {
    e.preventDefault();

    data.discounted = false;

    showQuizStep4(data);
  }

  const quizStep3QualificationMessage1 = document.getElementById('quiz-step-3-qualification-item-1');
  const quizStep3QualificationMessage2 = document.getElementById('quiz-step-3-qualification-item-2');
  const quizStep3QualificationMessage3 = document.getElementById('quiz-step-3-qualification-item-3');

  quizStep3QualificationMessage1.addEventListener('click', quizStep3SubmitEventHandler, true);
  quizStep3QualificationMessage2.addEventListener('click', quizStep3SubmitEventHandler, true);
  quizStep3QualificationMessage3.addEventListener('click', quizStep3SubmitEventHandler, true);

  quizStep3NoDiscount.addEventListener('click', quizStep3NoDiscountEventHandler, true);
  quizStep3Submit.addEventListener('click', quizStep3SubmitEventHandler, true);
  residentialPlanCard.addEventListener('click', quizStep3SubmitEventHandler, true);
  travelPlanCard.addEventListener('click', quizStep3SubmitEventHandler, true);
}

const showQuizStep4 = (data) => {
  const quizStep1 = document.getElementById('quiz-step-1');
  const quizStep2Road = document.getElementById('quiz-step-2-road');
  const quizStep2Home = document.getElementById('quiz-step-2-home');
  const quizStep3 = document.getElementById('quiz-step-3');
  const quizStep4 = document.getElementById('quiz-step-4');
  const quizStep5 = document.getElementById('quiz-step-5');

  quizStep5.style.display = 'none';
  quizStep1.style.display = 'none';
  quizStep2Road.style.display = 'none';
  quizStep2Home.style.display = 'none';
  quizStep3.style.display = 'none';
  quizStep4.style.display = 'flex';


  if (data.type == 'section') {
    data.sectionElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  data.currentStep = 4;

  const quizPopupBackButton = document.getElementById('quiz-back-button');
  quizPopupBackButton.style.display = 'flex';

  quizPopupBackButton.onclick = () => {
    showQuizStep3(data);
  }

  const quizProgressBarStep1 = document.getElementById('quiz-progress-bar-fill-1');
  const quizProgressBarStep2 = document.getElementById('quiz-progress-bar-fill-2');
  const quizProgressBarStep3 = document.getElementById('quiz-progress-bar-fill-3');
  const quizProgressBarStep4 = document.getElementById('quiz-progress-bar-fill-4');

  quizProgressBarStep1.style.width = '100%';
  quizProgressBarStep2.style.width = '100%';
  quizProgressBarStep3.style.width = '100%';
  quizProgressBarStep4.style.width = '0%';

  const quizProgressText = document.getElementById('quiz-progress-text');
  quizProgressText.innerText = 'Step 4 of 4';
  quizProgressText.style.display = 'block';

  const quizProgress = document.getElementById('quiz-progress');
  quizProgress.style.display = 'flex';

  const quizMainHeading1 = document.getElementById('quiz-heading-1');
  const quizMainHeading2 = document.getElementById('quiz-heading-2');
  const quizMainheading3 = document.getElementById('quiz-heading-3');
  const quizMainheading4 = document.getElementById('quiz-heading-4');
  const quizMainheading5 = document.getElementById('quiz-heading-5');
  const quizMainheading6 = document.getElementById('quiz-heading-6');

  quizMainHeading1.style.display = 'none';
  quizMainHeading2.style.display = 'none';
  quizMainheading3.style.display = 'none';
  quizMainheading4.style.display = 'none';
  quizMainheading5.style.display = 'none';
  quizMainheading6.style.display = 'none';

  const quizLoader = document.getElementById('quiz-popup-loader');
  const discountBadge = document.getElementById('quiz-heading-5-badge');

  if (data.discounted) {
    quizMainheading5.style.display = 'flex';
  } else {
    quizMainheading6.style.display = 'flex';
  }

  const quiz = document.getElementById('quiz');
  quiz.scrollTo(0, 0);

  let quizStep4Submit = document.getElementById('quiz-step-4-submit');
  const quizError = document.getElementById('quiz-error');
  const quizErrorMessage = document.getElementById('quiz-error-message');

  if (data.discounted) {
    quizStep4Submit.querySelector('div').innerText = 'CHECK MY ELIGIBILITY';
  } else {
    quizStep4Submit.querySelector('div').innerText = 'CONTINUE TO CHECKOUT';
  }

  const quizFormEmailField = document.getElementById('quiz-step-4-email');
  const quizFormSubmit = document.getElementById('quiz-button-container');
  quizFormEmailField.addEventListener('focus', (e) => {
    quizFormSubmit.scrollIntoView({ block: 'center', behavior: 'smooth' })
  })

  const quizFormPhoneField = document.getElementById('quiz-step-4-phone');
  quizFormPhoneField.addEventListener('keypress', (e) => {
    if (e.keyCode > 47 && e.keyCode < 58) {
      setTimeout(() => {
        let inputValue = e.target.value.replace(/\D/g, '');

        if (inputValue.length == 0) {
          inputStr = inputStr;
        } else if (inputValue.length < 4) {
          inputValue = '(' + inputValue;
        } else if (inputValue.length < 7) {
          inputValue = '(' + inputValue.substring(0, 3) + ') ' + inputValue.substring(3, 6);
        } else {
          inputValue =
            '(' + inputValue.substring(0, 3) + ') ' + inputValue.substring(3, 6) + '-' + inputValue.substring(6, 10);
        }

        e.target.value = inputValue;
      }, 100);
    } else {
      e.preventDefault();
    }
  })

  const quizStep4SubmitEventHandler = async (e) => {
    e.preventDefault();

    const firstNameInput = document.getElementById('quiz-step-4-first-name');
    const lastNameInput = document.getElementById('quiz-step-4-last-name');
    const emailInput = document.getElementById('quiz-step-4-email');
    const phoneInput = document.getElementById('quiz-step-4-phone');
    const zipInput = document.getElementById('quiz-step-4-zip');

    quizError.style.display = 'none';
    quizErrorMessage.innerText = 'An error occurred';

    data.firstName = firstNameInput.value.trim();
    data.lastName = lastNameInput.value.trim();
    data.email = emailInput.value.trim();
    data.phoneNumber = phoneInput.value.trim();
    data.zipCode = zipInput.value.trim();

    if (data.firstName === '') {
      quizErrorMessage.innerText = 'Please input first name'
      quizError.style.display = 'flex';
      quizError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    if (data.lastName === '') {
      quizErrorMessage.innerText = 'Please input last name'
      quizError.style.display = 'flex';
      quizError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    if (data.email === '') {
      quizErrorMessage.innerText = 'Please input email address'
      quizError.style.display = 'flex';
      quizError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    } else if (!validateEmail(data.email)) {
      quizErrorMessage.innerText = 'Please enter a valid email address'
      quizError.style.display = 'flex';
      quizError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    if (data.phoneNumber === '') {
      quizErrorMessage.innerText = 'Please input mobile number'
      quizError.style.display = 'flex';
      quizError.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    let payload = {
      first_name: data['firstName'].trim(),
      last_name: data['lastName'].trim(),
      email: data.email,
      phone: data.phoneNumber,
      zip_code: data.zipCode,
      road_use: data.roadUse,
      use_location: data.useLocation,
      source: 'Popup',
      home_use: data.homeUse.join(','),
      timestamp: new Date().toISOString(),
    };

    quizStep4Submit.innerHTML = '<div class="bar-loader"></div>';
    quizStep4Submit.disabled = true;

    let r = await fetch('https://app.lrlos.com/webhook/address-lookup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    quizStep4Submit.innerHTML = '<div></div>';
    quizStep4Submit.disabled = false;

    const step5NameDisplay = document.getElementById('quiz-step-5-name');
    step5NameDisplay.innerText = data.firstName;

    const chargebee = Chargebee.getInstance();

    const cart = chargebee.getCart();

    // Customer
    cart.setCustomer({
      first_name: data.firstName,
      last_name: data.lastName,
      email: data.email,
      phone: data.phoneNumber,
    });

    //  Shipping
    cart.setShippingAddress({
      first_name: data.firstName,
      last_name: data.lastName,
      line1: "",
      city: "",
      state_code: "",
      country: "US",
      zip: "",
    });

    const step5ButtonContainer = document.getElementById('quiz-button-container');

    const checkoutLinkResidentialStandard = step5ButtonContainer.querySelector('#cb-residential-standard-cc');
    const checkoutLinkTravelStandard = step5ButtonContainer.querySelector('#cb-travel-standard-cc');
    const checkoutLinkTravelAdvanced = step5ButtonContainer.querySelector('#cb-travel-advanced-cc');

    if (data.discounted) {
      showQuizStep5(data);
    } else {
      switch (data.useLocation) {
        case 'home':
          checkoutLinkResidentialStandard.click();
          break;
        case 'road':
          checkoutLinkTravelStandard.click()
          break;
        case 'home-road':
          checkoutLinkTravelAdvanced.click()
          break;
      }
    }
  }

  const quizButtonContainer = document.getElementById('quiz-button-container-main');

  const buttonClone = quizStep4Submit.cloneNode(true);
  quizButtonContainer.innerHTML = '';
  quizButtonContainer.appendChild(buttonClone);

  quizStep4Submit = document.getElementById('quiz-step-4-submit');

  quizStep4Submit.addEventListener('click', quizStep4SubmitEventHandler, true);
}

const showQuizStep5 = (data) => {
  const quizStep1 = document.getElementById('quiz-step-1');
  const quizStep2Road = document.getElementById('quiz-step-2-road');
  const quizStep2Home = document.getElementById('quiz-step-2-home');
  const quizStep3 = document.getElementById('quiz-step-3');
  const quizStep4 = document.getElementById('quiz-step-4');
  const quizStep5 = document.getElementById('quiz-step-5');

  quizStep5.style.display = 'flex';
  quizStep4.style.display = 'none';
  quizStep3.style.display = 'none';
  quizStep2Road.style.display = 'none';
  quizStep2Home.style.display = 'none';
  quizStep1.style.display = 'none';


  if (data.type == 'section') {
    data.sectionElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
  }

  data.currentStep = 5;

  const quizPopupBackButton = document.getElementById('quiz-back-button');

  quizPopupBackButton.onclick = () => {
    showQuizStep4(data);
  }

  const quizProgressText = document.getElementById('quiz-progress-text');
  quizProgressText.style.display = 'none';

  const quizProgress = document.getElementById('quiz-progress');
  quizProgress.style.display = 'none';

  const quizProgressBarStep1 = document.getElementById('quiz-progress-bar-fill-1');
  const quizProgressBarStep2 = document.getElementById('quiz-progress-bar-fill-2');
  const quizProgressBarStep3 = document.getElementById('quiz-progress-bar-fill-3');
  const quizProgressBarStep4 = document.getElementById('quiz-progress-bar-fill-4');

  quizProgressBarStep1.style.width = '100%';
  quizProgressBarStep2.style.width = '100%';
  quizProgressBarStep3.style.width = '100%';
  quizProgressBarStep4.style.width = '100%';

  const quizMainHeading1 = document.getElementById('quiz-heading-1');
  const quizMainHeading2 = document.getElementById('quiz-heading-2');
  const quizMainheading3 = document.getElementById('quiz-heading-3');
  const quizMainheading4 = document.getElementById('quiz-heading-4');
  const quizMainheading5 = document.getElementById('quiz-heading-5');
  const quizMainheading6 = document.getElementById('quiz-heading-6');

  quizMainHeading1.style.display = 'none';
  quizMainHeading2.style.display = 'none';
  quizMainheading3.style.display = 'none';
  quizMainheading4.style.display = 'none';
  quizMainheading5.style.display = 'none';
  quizMainheading6.style.display = 'none';

  const quizPopup2Main = document.getElementById('quiz');
  quizPopup2Main.scrollTo(0, 0);

  const step5ButtonContainer = document.getElementById('quiz-button-container');

  const checkoutLinkResidentialStandard = step5ButtonContainer.querySelector('#cb-residential-standard-cc');
  const checkoutLinkResidentialAdvanced = step5ButtonContainer.querySelector('#cb-residential-advanced-cc');
  const checkoutLinkTravelStandard = step5ButtonContainer.querySelector('#cb-travel-standard-cc');
  const checkoutLinkTravelAdvanced = step5ButtonContainer.querySelector('#cb-travel-advanced-cc');
  const checkoutLinkResidentialStandardWithCoupon = step5ButtonContainer.querySelector('#cb-residential-standard-with-coupon');
  const checkoutLinkResidentialAdvancedWithCoupon = step5ButtonContainer.querySelector('#cb-residential-advanced-with-coupon');
  const checkoutLinkTravelStandardWithCoupon = step5ButtonContainer.querySelector('#cb-travel-standard-with-coupon');
  const checkoutLinkTravelAdvancedWithCoupon = step5ButtonContainer.querySelector('#cb-travel-advanced-with-coupon');
  const checkoutLinkResidentialStandardWithCoupon15 = step5ButtonContainer.querySelector('#cb-residential-standard-with-coupon-15');
  const checkoutLinkResidentialAdvancedWithCoupon15 = step5ButtonContainer.querySelector('#cb-residential-advanced-with-coupon-15');
  const checkoutLinkTravelStandardWithCoupon15 = step5ButtonContainer.querySelector('#cb-travel-standard-with-coupon-15');
  const checkoutLinkTravelAdvancedWithCoupon15 = step5ButtonContainer.querySelector('#cb-travel-advanced-with-coupon-15');

  const quizLoader = document.getElementById('quiz-popup-loader');

  const step5SubmitHandler = async (e) => {
    e.preventDefault();

    switch (data.useLocation) {
      case 'home':
        checkoutLinkResidentialStandardWithCoupon15.click();
        break;
      case 'road':
        checkoutLinkTravelStandardWithCoupon15.click();
        break;
      case 'home-road':
        checkoutLinkTravelAdvancedWithCoupon15.click();
        break;
    }

    submitButton.disabled = false;
  }

  const quizStep5Submit = document.getElementById('quiz-step-5-submit');
  quizStep5Submit.addEventListener('click', step5SubmitHandler, true);
}
